module.exports = __webpack_public_path__ + "img/cszq_partners_1.fdaddc15.jpg";